



















































import Vue from 'vue'

interface ComponentData {
  positions: any
  toolbarWidth: number
  areaWidth: number
  note: string
}

export default Vue.extend({
  name: 'NoteDialog',

  components: {},

  props: {
    show: {
      type: Boolean,
      default: false
    },
    title: String,
    dialogNote: String,
    isSaveInProgress: Boolean
  },

  data (): ComponentData {
    return {
      positions: {
        clientX: undefined,
        clientY: undefined,
        movementX: 0,
        movementY: 0
      },
      toolbarWidth: 900,
      areaWidth: 900,
      note:''
    }
  },

  computed: {
    getPosition (): Object {
      const top : number = (window.innerHeight - 100 - 400) / 2
      const left : number = (window.innerWidth - this.areaWidth) / 2
      return {top: `${top}px`, left: `${left}px`}
    },
  },

  methods: {
    onCloseButtonClick (): void {
      this.$emit('close')
    },

    dragMouseDown: function (event: any) {
      event.preventDefault()
      this.positions.clientX = event.clientX
      this.positions.clientY = event.clientY
      document.onmousemove = this.elementDrag
      document.onmouseup = this.closeDragElement
    },

    elementDrag: function (event: any) {
      // @ts-ignore
      const container: HTMLElement = this.$refs['draggableContainer']
      event.preventDefault()

      this.positions.movementX = this.positions.clientX - event.clientX
      this.positions.movementY = this.positions.clientY - event.clientY
      this.positions.clientX = event.clientX
      this.positions.clientY = event.clientY

      if((container.offsetTop - this.positions.movementY) > -64 && (container.offsetTop - this.positions.movementY + container.clientHeight + 64) < event.view.innerHeight) {
        container.style.top = (container.offsetTop - this.positions.movementY) + 'px'
      } else if ((container.offsetTop - this.positions.movementY) < -64) {
        container.style.top = -64 + 'px'
      } else if ((container.offsetTop - this.positions.movementY) + container.clientHeight + 64 > event.view.innerHeight) {
        container.style.top = (event.view.innerHeight - (container.clientHeight + 64)) + 'px'
      }

      if((container.offsetLeft - this.positions.movementX) > 0 && (container.offsetLeft - this.positions.movementX + container.clientWidth + 18) < event.view.innerWidth) {
        container.style.left = (container.offsetLeft - this.positions.movementX) + 'px'
      } else if((container.offsetLeft - this.positions.movementX) < 0) {
        container.style.left = 0 + 'px'
      } else if((container.offsetLeft - this.positions.movementX + container.clientWidth + 18) > event.view.innerWidth) {
        container.style.left = (event.view.innerWidth - container.clientWidth - 18) + 'px'
      }
    },

    closeDragElement () {
      document.onmouseup = null
      document.onmousemove = null
    },

    onCancelButtonClick (): void {
      this.$emit('close')
    },

    onSaveButtonClick (): void {
      this.$emit('save', this.note)
    }

  },

  mounted (): void {
    this.note = this.dialogNote
    this.areaWidth = (window.innerWidth - 50) > 900 ? 900 : window.innerWidth - 50
    this.toolbarWidth = this.areaWidth
  }
})
